import {Elements} from '@stripe/react-stripe-js';
import {loadStripe} from '@stripe/stripe-js';
import StripeCheckoutForm from './StripeCheckoutForm'


const StripeCheckout = (props) => {
  const stripePromise= loadStripe(props.publicKey);
  const stripeOptions = {
    clientSecret: props.clientSecret
  }
  return <><Elements stripe={stripePromise} options={stripeOptions}>
    <StripeCheckoutForm props={props}/>
  </Elements></>
}
export default StripeCheckout;